import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=b105e04a&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b105e04a')) {
      api.createRecord('b105e04a', component.options)
    } else {
      api.reload('b105e04a', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=b105e04a&", function () {
      api.rerender('b105e04a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28Se2gCaGzT4S/JS/comp/IncreaseNumber.vue"
export default component.exports